import { render, staticRenderFns } from "./Renew.vue?vue&type=template&id=1c05d17e&scoped=true"
import script from "./Renew.vue?vue&type=script&lang=js"
export * from "./Renew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c05d17e",
  null
  
)

export default component.exports